<template>
  <div><BMRCalc /></div
></template>

<script>
import BMRCalc from "../components/BMRCalc";

export default {
  data: () => ({}),
  components: {
    BMRCalc,
  },
  methods: {},
};
</script>

<style></style>
